// pedro.lima@wefit.com.br (12/2025): Fernando solicitou que essas implementações de tracking no módulo de tracking integrado fossem desativadas
// Essa chamada estava com problema de CORS, e foi sugerido pelo mesmo, parar o disparo e exibição referente!
// Nada foi removido, apenas comentado! Os demais blocos dependentes à este estão com "(12-2025-Tracking-Cors)" como identificador!


/* eslint-disable no-unused-vars */
/* eslint-disable no-case-declarations */
import axios from 'axios';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// eslint-disable-next-line camelcase
import { apiKey, baseURL, tracking_manager } from '../constants/Endpoints';
import { showToastError, showToastSuccess } from '../components/toasty';

const GET_CUSTOMER_USERS_LIST = 'luft/customer/GET_CUSTOMER_USERS_LIST';
const GET_CUSTOMER_USERS_LIST_SUCCESS =
  'luft/customer/GET_CUSTOMER_USERS_LIST_SUCCESS';
const GET_CUSTOMER_USERS_LIST_FAILURE =
  'luft/customer/GET_CUSTOMER_USERS_LIST_FAILURE';

const CREATE_CUSTOMER_USER = 'luft/customer/CREATE_CUSTOMER_USER';
const CREATE_CUSTOMER_USER_SUCCESS =
  'luft/customer/CREATE_CUSTOMER_USER_SUCCESS';
const CREATE_CUSTOMER_USER_FAILURE =
  'luft/customer/CREATE_CUSTOMER_USER_FAILURE';

const UPDATE_CUSTOMER_USER = 'luft/admin-platform-users/UPDATE_CUSTOMER_USER';
const UPDATE_CUSTOMER_USER_SUCCESS =
  'luft/admin-platform-users/UPDATE_CUSTOMER_USER_SUCCESS';
const UPDATE_CUSTOMER_USER_FAILURE =
  'luft/admin-platform-users/UPDATE_CUSTOMER_USER_FAILURE';

const GET_CUSTOMER_COMPANY_LIST = 'luft/customer/GET_CUSTOMER_COMPANY_LIST';
const GET_CUSTOMER_COMPANY_LIST_SUCCESS =
  'luft/customer/GET_CUSTOMER_COMPANY_LIST_SUCCESS';
const GET_CUSTOMER_COMPANY_LIST_FAILURE =
  'luft/customer/GET_CUSTOMER_COMPANY_LIST_FAILURE';

const UPDATE_CUSTOMER_TRACKING = 'luft/customer/UPDATE_CUSTOMER_TRACKING';
const UPDATE_CUSTOMER_TRACKING_SUCCESS =
  'luft/customer/UPDATE_CUSTOMER_TRACKING_SUCCESS';
const UPDATE_CUSTOMER_TRACKING_FAILURE =
  'luft/customer/UPDATE_CUSTOMER_TRACKING_FAILURE';

const SHOW_REGISTER_MODAL = 'luft/customer/SHOW_REGISTER_MODAL';

const RESEND_EMAIL_CONFIRMATION_LOADING = 'luft/tracking/RESEND_EMAIL_CONFIRMATION_LOADING';
const RESEND_EMAIL_CONFIRMATION_SUCCESS = 'luft/tracking/RESEND_EMAIL_CONFIRMATION_SUCCESS';
const RESEND_EMAIL_CONFIRMATION_FAILURE = 'luft/tracking/RESEND_EMAIL_CONFIRMATION_FAILURE';

const initialState = {
  customerUsersList: {
    isFetching: false,
    error: '',
    data: [],
    totalItems: 0,
    currentPage: 1,
    pageLimit: 5, // Default 10
  },
  customerCompanyList: {
    isFetching: false,
    error: '',
    data: [],
  },
  customerUser: {
    isFetching: false,
    error: '',
  },
  resendEmailConfirmation: {
    loading: false,
    error: '',
    success: false,
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_CUSTOMER_USERS_LIST: {
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: true,
          error: '',
        },
      };
    }

    case GET_CUSTOMER_USERS_LIST_SUCCESS: {
      const { data, page } = action;
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: '',
          data: data.list,
          totalItems: data.count,
          currentPage: page,
        },
      };
    }

    case GET_CUSTOMER_USERS_LIST_FAILURE: {
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: action.error,
        },
      };
    }

    case CREATE_CUSTOMER_USER:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: true,
          error: '',
        },
        customerUser: {
          ...state.customerUser,
          isFetching: true,
          error: '',
        },
      };

    case CREATE_CUSTOMER_USER_SUCCESS:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: '',
        },
        customerUser: {
          ...state.customerUser,
          isFetching: false,
          error: '',
        },
      };

    case CREATE_CUSTOMER_USER_FAILURE:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: action.error,
        },
        customerUser: {
          ...state.customerUser,
          isFetching: false,
          error: action.error,
        },
      };

    case UPDATE_CUSTOMER_USER:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: true,
          error: '',
        },
      };

    case UPDATE_CUSTOMER_USER_SUCCESS:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: '',
        },
      };

    case UPDATE_CUSTOMER_USER_FAILURE:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: action.error,
        },
        customerUser: {
          ...state.customerUser,
          isFetching: false,
          error: action.error,
        },
      };

    case UPDATE_CUSTOMER_TRACKING:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: true,
          error: '',
        },
      };

    case UPDATE_CUSTOMER_TRACKING_SUCCESS:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: '',
        },
      };

    case UPDATE_CUSTOMER_TRACKING_FAILURE:
      return {
        ...state,
        customerUsersList: {
          ...state.customerUsersList,
          isFetching: false,
          error: action.error,
        },
      };

    case GET_CUSTOMER_COMPANY_LIST:
      return {
        ...state,
        customerCompanyList: {
          ...state.customerCompanyList,
          isFetching: true,
          error: '',
        },
      };

    // eslint-disable-next-line no-case-declarations
    case GET_CUSTOMER_COMPANY_LIST_SUCCESS:
      const { list } = action;
      return {
        ...state,
        customerCompanyList: {
          ...state.customerCompanyList,
          isFetching: false,
          error: '',
          data: list,
        },
      };

    case GET_CUSTOMER_COMPANY_LIST_FAILURE:
      return {
        ...state,
        customerCompanyList: {
          ...state.customerCompanyList,
          isFetching: false,
          error: action.error,
        },
      };

    case RESEND_EMAIL_CONFIRMATION_LOADING:
      return {
        ...state,
        resendEmailConfirmation: {
          ...state.resendEmailConfirmation,
          loading: !state.resendEmailConfirmation.loading,
        },
      };

    case RESEND_EMAIL_CONFIRMATION_SUCCESS:
      return {
        ...state,
        resendEmailConfirmation: {
          ...state.resendEmailConfirmation,
          loading: false,
          error: '',
          success: true,
        },
      };

    case RESEND_EMAIL_CONFIRMATION_FAILURE:
      return {
        ...state,
        resendEmailConfirmation: {
          ...state.resendEmailConfirmation,
          loading: false,
          error: action.error,
          success: false,
        },
      };

    default:
      return state;
  }
}

export default reducer;

function _getCustomerUsersList() {
  return {
    type: GET_CUSTOMER_USERS_LIST,
  };
}

function _getCustomerUsersListSuccess(data, page) {
  return {
    type: GET_CUSTOMER_USERS_LIST_SUCCESS,
    data,
    page,
  };
}

function _getCustomerUsersListError(error) {
  return {
    type: GET_CUSTOMER_USERS_LIST_FAILURE,
    error,
  };
}

export function _createCustomerUser() {
  return { type: CREATE_CUSTOMER_USER };
}

export function _createCustomerUserSuccess() {
  return {
    type: CREATE_CUSTOMER_USER_SUCCESS,
  };
}

function _createCustomerUserError(error) {
  return {
    type: CREATE_CUSTOMER_USER_FAILURE,
    error,
  };
}

export function _updateCustomerUser() {
  return { type: UPDATE_CUSTOMER_USER };
}

function _updateCustomerUserSuccess() {
  return {
    type: UPDATE_CUSTOMER_USER_SUCCESS,
  };
}

function _updateCustomerUserFailure(error) {
  return {
    type: UPDATE_CUSTOMER_USER_FAILURE,
    error,
  };
}

function _getCustomerCompanyList() {
  return {
    type: GET_CUSTOMER_COMPANY_LIST,
  };
}

function _getCustomerCompanyListSuccess(list) {
  return {
    type: GET_CUSTOMER_COMPANY_LIST_SUCCESS,
    list,
  };
}

function _getCustomerCompanyListError(error) {
  return {
    type: GET_CUSTOMER_COMPANY_LIST_FAILURE,
    error,
  };
}

function _resendEmailConfirmation() {
  return {
    type: RESEND_EMAIL_CONFIRMATION_LOADING,
  };
}

function _resendEmailConfirmationSuccess() {
  return {
    type: RESEND_EMAIL_CONFIRMATION_SUCCESS,
  };
}

function _resendEmailConfirmationError(error) {
  return {
    type: RESEND_EMAIL_CONFIRMATION_FAILURE,
    error,
  };
}

export function _showRegisterModal() {
  return {
    type: SHOW_REGISTER_MODAL,
  };
}

export function getCustomerUsersList(query) {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_getCustomerUsersList());

      const { taxNumber, name, page, take } = query;

      // eslint-disable-next-line prefer-destructuring
      const pageLimit = take || getState().trackingManager.customerUsersList.pageLimit;

      const url = `${baseURL}${tracking_manager.GET_CUSTOMER_USERS_LIST}`;

      const handleSkip = () => {
        if ((page - 1) * pageLimit > 0) {
          return (page - 1) * pageLimit;
        }
        return 0;
      };

      try {
        const response = await axios.get(url, {
          headers: {
            'api-td-key': apiKey,
          },
          params: {
            name: name || null,
            taxNumber: taxNumber || null,
            skip: handleSkip(),
            take: pageLimit,
          },
        });

        dispatch(_getCustomerUsersListSuccess(response.data, page));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getCustomerUsersListError(error.message),
        );
      }
    })();
  };
}

export function getCustomerCompanyList() {
  return function (dispatch) {
    (async () => {
      dispatch(_getCustomerCompanyList());

      const customerCompanyId = window.localStorage.getItem('Luft/CustomerService/CompanyId');
      const userCompanyId = window.localStorage.getItem('Luft/CompanyId');

      const resultID = (customerCompanyId !== 'undefined' && customerCompanyId) || (userCompanyId !== 'undefined' && userCompanyId);

      const url = `${baseURL}${tracking_manager.GET_CUSTOMER_COMPANIES_LIST}${resultID}`;

      try {
        const response = await axios.get(url, {
          headers: {
            'api-td-key': apiKey,
          },
          params: {
            take: 5000,
          },
        });

        dispatch(_getCustomerCompanyListSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getCustomerCompanyListError(error.message),
        );
      }
    })();
  };
}

export function ResendEmailConfirmation(data) {
  return function (dispatch) {
    (async () => {
      dispatch(_resendEmailConfirmation());

      const url = `${baseURL}${tracking_manager.RESEND_EMAIL}`;

      try {
        const {
          userId,
        } = data;

        await axios.put(url, { userId }, {
          headers: {
            'api-td-key': apiKey,
          },
        });

        showToastSuccess("E-mail enviado com sucesso!");
        dispatch(_resendEmailConfirmationSuccess());
      } catch (error) {
        console.log(error);
        showToastError("Ocorreu um erro ao enviar o e-mail.");
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _resendEmailConfirmationError(error.message),
        );
      }
    })();
  };
}

export function createCustomerUser(data, callback) {
  return function (dispatch) {
    (async () => {
      dispatch(_createCustomerUser());
      try {
        const {
          name, email, phone, taxNumber, trackingActive,
        } = data;

        const customerCompanyId = window.localStorage.getItem('Luft/CustomerService/CompanyId');
        const userCompanyId = window.localStorage.getItem('Luft/CompanyId');

        const resultID = (customerCompanyId !== 'undefined' && customerCompanyId) || (userCompanyId !== 'undefined' && userCompanyId);

        const url = `${baseURL}${tracking_manager.CREATE_CUSTOMER_USER}${resultID}`;

        const payload = phone === '' ? {
          name,
          email,
          taxNumber,
          tracking: trackingActive,
        } : {
          name,
          email,
          phone,
          taxNumber,
          tracking: trackingActive,
        };

        await axios.post(
          url,
          payload,
          {
            headers: {
              'api-td-key': apiKey,
            },
          },
        );

        showToastSuccess("Usuário adicionado com sucesso!");
        dispatch(_createCustomerUserSuccess());
        dispatch(getCustomerUsersList({ taxNumber, page: 1 }));
        if (callback) {
          callback();
        }
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _createCustomerUserError(error.response.data.message),
          );
      }
    })();
  };
}

export function updateCustomerUser(data) {
  return function (dispatch) {
    (async () => {
      dispatch(_updateCustomerUser());

      const {
        id, name, email, phone, trackingActive, taxNumber
      } = data;

      const url = `${baseURL}${tracking_manager.UPDATE_CUSTOMER_USER}${id}`;

      const payload = !phone ? {
        name,
        email,
        taxNumber,
        tracking: trackingActive,
      } :
      {
        name,
        email,
        phone,
        taxNumber,
        tracking: trackingActive,
      };

      try {
        await axios.put(
          url,
          payload,
          {
            headers: {
              'api-td-key': apiKey,
            },
          },
        );

        showToastSuccess("Usuário alterado com sucesso!");
        dispatch(_updateCustomerUserSuccess());
        dispatch(getCustomerUsersList({ taxNumber, page: 1 }));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _updateCustomerUserFailure(error.message),
        );
      }
    })();
  };
}

export function updateCustomerTrackingUser(data) {
  return function (dispatch) {
    (async () => {

      const { taxNumber, userId, hasTracking } = data;
      
      const customerCompanyId = window.localStorage.getItem('Luft/CustomerService/CompanyId');
      const userCompanyId = window.localStorage.getItem('Luft/CompanyId');

      const resultID = (customerCompanyId !== 'undefined' && customerCompanyId) || (userCompanyId !== 'undefined' && userCompanyId);

      const url = `${baseURL}${tracking_manager.UPDATE_CUSTOMER_TRACKING}`;

      try {
        await axios.put(
          url,
          {
            companyId: resultID,
            userId,
            hasTracking,
          },
          {
            headers: {
              'api-td-key': apiKey,
            },
          },
        );

        showToastSuccess("Usuário alterado com sucesso!");
        dispatch(_updateCustomerUserSuccess());
        dispatch(getCustomerCompanyList());
        if (taxNumber) {
          dispatch(getCustomerUsersList({ taxNumber, page: 1 }));
        }
      } catch (error) {
        console.log(error);

        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _updateCustomerUserFailure(error.message),
        );
      }
    })();
  };
}

export function updateCustomerTracking(data) {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_updateCustomerUser());

      const id = getState().auth.activeCompanyId;

      const { taxNumber, hasTracking } = data;

      const url = `${baseURL}${tracking_manager.UPDATE_CUSTOMER_TRACKING}`;

      try {
        await axios.post(
          url,
          {
            companyId: id,
            taxNumber,
            hasTracking,
          },
          {
            headers: {
              'api-td-key': apiKey,
            },
          },
        );

        dispatch(_updateCustomerUserSuccess());
      } catch (error) {
        console.log(error);

        if (error.response.status === 400) {
          dispatch(_showRegisterModal());
        }

        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _updateCustomerUserFailure(error.message),
        );
      }
    })();
  };
}
